module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre Mirdif City Centre.60132665.jpg";